import queryString from "query-string"

export const setQueryParameter = (url, key, value) => {
  if (!url) return ""

  try {
    const {
      url: baseUrl,
      query,
      fragmentIdentifier,
    } = queryString.parseUrl(url, { parseFragmentIdentifier: true })

    return queryString.stringifyUrl({
      fragmentIdentifier,
      query: { ...query, [key]: value },
      url: baseUrl,
    })
  } catch (e) {
    return url
  }
}
